export function DatePickerInput(input, datepicker) {
	let currentDate = parse(input.value);

	hide();

	setSelectedDate(parse(input.value));

	datepicker.config.container.addEventListener('dayClick', event => {
		let { date } = event.detail;

		hide();
		setSelectedDate(date);
		input.value = format(date);
	});

	input.setAttribute('readonly', 'true');
	input.setAttribute('autocomplete', 'off');

	input.addEventListener('focus', show);
	input.addEventListener('click', show);

	document.addEventListener('click', event => {
		let { target } = event;

		if (target === input || datepicker.config.container.contains(target)) {
			return;
		}

		hide();
	});

	function format(date) {
		let d = String(date.getDate()).padStart(2, '0');
		let m = String(date.getMonth() + 1).padStart(2, '0');
		let y = date.getFullYear();

		return [d, m, y].join('/');
	}

	function parse(value) {
		let parts = value.split('/');

		let d = parseInt(parts[0], 10);
		let m = parseInt(parts[1], 10) - 1;
		let y = parseInt(parts[2], 10);

		return new Date(y, m, d);
	}

	function setSelectedDate(date) {
		currentDate = date;
		return datepicker.set('modifiers.selected', date);
	}

	function getCurrentDate() {
		return currentDate;
	}

	function show() {
		input.classList.add('active');
		datepicker.config.container.removeAttribute('hidden');
	}

	function hide() {
		input.classList.remove('active');
		datepicker.config.container.setAttribute('hidden', '');
	}

	return { getCurrentDate, show, hide, ...datepicker };
}
